import { LocalStorageKey } from '@shared/constants/localStorageKey';

export const DEFAULT_PAGINATION_SIZE = 100;

export const initialPaginationSize = (key: LocalStorageKey) => {
  const paginationSize = localStorage.getItem(key);

  return Number(paginationSize) || DEFAULT_PAGINATION_SIZE;
};

export const setPaginationSize = (key: LocalStorageKey, size: number) => {
  localStorage.setItem(key, size.toString());
};
